import React, { useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Legend
} from "chart.js";
import InfoIcon from "../../../assets/icons/info-icon.svg";
import FinanceCardChart from "../financeCardChart/financeCardChart";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Legend);

const FinanceActiveStudentsEvolution = ({ series = [], code }) => {
  const [showPopover, setShowPopover] = useState(false);

  const sorted = [...series].sort(
    (a, b) => (a.yearMonth || 0) - (b.yearMonth || 0)
  );

  const data = {
    labels: sorted.map((row) => row.month),
    datasets: [
      {
        label: "Alunos ativos",
        data: sorted.map((row) => row.activeStudentsCount ?? 0),
        borderColor: "#0962AD",
        backgroundColor: "#0962AD",
        borderWidth: 2
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        align: "end",
        labels: {
          boxHeight: 6,
          boxWidth: 10,
          color: "#858585",
          font: { size: 14 }
        }
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.raw}`;
          }
        }
      }
    },
    scales: {
      x: { grid: { display: false } },
      y: {
        ticks: {
          precision: 0
        },
        position: "left",
        title: {
          display: true,
          text: "Quantidade de alunos"
        }
      }
    }
  };

  return (
    <FinanceCardChart
      code={code}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span>Evolução de alunos ativos</span>
          <div style={{ position: "relative" }}>
            <img
              src={InfoIcon}
              alt="Informação"
              onClick={() => setShowPopover(!showPopover)}
              style={{
                width: "14px",
                height: "14px",
                cursor: "pointer",
                verticalAlign: "middle",
                display: "inline-block"
              }}
            />
            {showPopover && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "100%",
                  transform: "translate(0, -50%)",
                  marginLeft: "8px",
                  backgroundColor: "#fff",
                  border: "1px solid #ccc",
                  padding: "10px",
                  zIndex: 100,
                  width: "260px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  borderRadius: "4px"
                }}
              >
                <p style={{ margin: 0, fontSize: "12px", fontWeight: "normal" }}>
                  Contagem mensal de alunos com vínculo acadêmico ativo (status
                  como Ativo, Matriculado, Cursando, etc.) que se sobrepõem a
                  cada mês do período selecionado. Os filtros de curso / turma,
                  quando aplicados, restringem as disciplinas consideradas.
                </p>
                <button
                  type="button"
                  onClick={() => setShowPopover(false)}
                  style={{
                    marginTop: "8px",
                    fontSize: "10px",
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    color: "#0962AD"
                  }}
                >
                  Fechar
                </button>
              </div>
            )}
          </div>
        </div>
      }
    >
      <Line data={data} options={options} />
    </FinanceCardChart>
  );
};

export default FinanceActiveStudentsEvolution;
